

import { createSlice } from '@reduxjs/toolkit';

export const jobSlice = createSlice({
    name: 'JOB',
    initialState: {
        loading: false,
        data: {

        },
        main_data: [],
        error: false,
    },
    reducers: {
        JOB_FETCH_START: (state) => {
            state.loading = true
        },
        JOB_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            state.data = action.payload
            state.main_data = action.payload.sites
        },
        JOB_FETCH_MORE_SUCCESS: (state, action) => {
            state.loading = false
            state.data = action.payload
            state.main_data=[...state.main_data,...action.payload.sites]
        },
        ADD_JOB_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            state.main_data = [action.payload, ...state.main_data]
        },
        EDIT_JOB_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            const newArray = state.main_data.filter(todo => todo.id !== action.payload.id)
            state.main_data = [...newArray, action.payload]
        },
        DELETE_JOB: (state, action) => {
            const filterPosts = state.main_data.filter(
                (post) => post.id !== action.payload
            );
            state.loading = false
            state.main_data = filterPosts
        },
        JOB_FETCH_ERROR: (state) => {
            state.error = true
        }
    }
});

export const {JOB_FETCH_MORE_SUCCESS, DELETE_JOB, EDIT_JOB_FETCH_SUCCESS, JOB_FETCH_START, JOB_FETCH_SUCCESS, JOB_FETCH_ERROR, ADD_JOB_FETCH_SUCCESS } = jobSlice.actions;
export default jobSlice.reducer;